import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCheckbox,_vm._b({attrs:{"color":"input"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',[_vm._v(_vm._s(_vm.label))])]},proxy:true}])},'v-checkbox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }